import React, {Component} from 'react';
import {Button,Modal,FormControl,DropdownButton,MenuItem,Row,Col,FormGroup,ControlLabel,Tabs,Tab,Form} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import WorkdocStore from '../../../stores/WorkdocStore'
import Select from 'react-select';
// import ConfirmPopup from '../../../component/element/ConfirmPopup'
import DatePicker from '../../../component/element/DatePicker'
import RemarkRecordModal from '../../../component/element/RemarkRecordModal'
import CKAutocomplete from '../../../component/element/CKAutocomplete'
import { Checkbox } from 'react-icheck';
import ReceiptVoucherDoc from '../../doc/ReceiptVoucherDoc'
import ConfirmPopup from 'component/element/ConfirmPopup'
var NotificationSystem = require('react-notification-system');

const DEFAULT_CASH = {payment_method:'CASH',payment_date:'',amount:'',net:'',remark:'',wh_status:false,wh_val:0}
const DEFAULT_CHECK = {payment_method:'CHECK',payment_date:'',bank:'',number:'',check_date:'',amount:'',fee:'',net:'',wh_status:false,wh_val:0,remark:''}
const DEFAULT_TRANSFER = {payment_method:'TRANSFER',payment_date:'',bank:'',number:'',amount:'',fee:'',net:'',wh_status:false,wh_val:0,remark:''}
const DEFAULT_CREDIT = {payment_method:'CREDIT',payment_date:'',bank:'',credit:'',amount:'',fee:'',net:'',wh_status:false,wh_val:0,remark:''}
class InvoiceStatusMenuButton extends Component {

  constructor(...args){
    super(...args)
    this.state = {
			show:false,
			showConfirm:false,
			showConfirmTaxinvoice:false,
			taxinvoice_no:null,
			docTag:'status',
      showRemark:false,
      remarkTitle:'',
			confirmMessage:'',
    	bankList:[{label:'ธนาคารกรุงเทพ',value:'ธนาคารกรุงเทพ'},{label:'ธนาคารกสิกรไทย',value:'ธนาคารกสิกรไทย'},{label:'ธนาคารกรุงไทย',value:'ธนาคารกรุงไทย'},{label:'ธนาคารทหารไทย',value:'ธนาคารทหารไทย'},{label:'ธนาคารไทยพาณิชย์',value:'ธนาคารไทยพาณิชย์'},{label:'ธนาคารกรุงศรีอยุธยา',value:'ธนาคารกรุงศรีอยุธยา'},{label:'ธนาคารเกียรตินาคิน',value:'ธนาคารเกียรตินาคิน'},{label:'ธนาคารซีไอเอ็มบีไทย',value:'ธนาคารซีไอเอ็มบีไทย'},{label:'ธนาคารทิสโก้',value:'ธนาคารทิสโก้'},{label:'ธนาคารธนชาต',value:'ธนาคารธนชาต'},{label:'ธนาคารยูโอบี',value:'ธนาคารยูโอบี'},{label:'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)',value:'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)'},{label:'ธนาคารไทยเครดิตเพื่อรายย่อย',value:'ธนาคารไทยเครดิตเพื่อรายย่อย'},{label:'ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย',value:'ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย'},{label:'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',value:'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร'},{label:'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย',value:'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย'},{label:'ธนาคารออมสิน',value:'ธนาคารออมสิน'},{label:'ธนาคารอาคารสงเคราะห์',value:'ธนาคารอาคารสงเคราะห์'},{label:'ธนาคารอิสลามแห่งประเทศไทย',value:'ธนาคารอิสลามแห่งประเทศไทย'}],
    	bank:'',
    	input_cash:DEFAULT_CASH,
    	input_check:DEFAULT_CHECK,
    	input_transfer:DEFAULT_TRANSFER,
			input_credit:DEFAULT_CREDIT,
			taxIncluded:this.props.hasVat,
			is_voucher:false,
			showVoucher:false
    }
	}
	
	componentWillReceiveProps(newProps){
		//this.setState()
	}

  loadPayment() {
  	
  	let {input_cash,input_check,input_transfer,input_credit,bankList} = this.state
  	WorkdocStore.loadPayment(this.props.ivNo,this.props.docType,(result)=> {
			if(result.data.payment_method==='CASH'){
				input_cash = Object.assign(DEFAULT_CASH,result.data)
				this.setState({input_cash:input_cash,activeKey:1})
			}else if(result.data.payment_method==='CHECK'){
				input_check = Object.assign(DEFAULT_CHECK,result.data)
				this.setState({input_check:input_check,activeKey:2})
			}else if(result.data.payment_method==='TRANSFER'){
				input_transfer = Object.assign(DEFAULT_TRANSFER,result.data)
				this.setState({input_transfer:input_transfer,activeKey:3})
			}else if(result.data.payment_method==='CREDIT'){
				input_cash = Object.assign(DEFAULT_CREDIT,result.data)
				this.setState({input_credit:input_credit,activeKey:4})
			}  
		if(result.bank_list && result.bank_list.length>0){
			bankList = result.bank_list
		}	
  		this.setState({show:true,bankList:bankList,taxinvoice_no:result.data.taxinvoice_no})
  	})
  }  		

  onSaveClick(e){
  	let {input_cash,input_check,input_transfer,input_credit,activeKey,is_voucher,taxinvoice_no} = this.state
  	let obj = {}
  	
  	if (activeKey===1) {
  		obj = input_cash
  	}else if (activeKey===2) {
  		obj = input_check
  	}else if (activeKey===3) {
  		obj = input_transfer
  	}else if (activeKey===4) {
  		obj = input_credit
  	}

  	let postData = {iv: this.props.ivNo, payment_detail: obj}
  	WorkdocStore.savePayment(postData,this.props.ivNo,this.props.docType,(result)=> {
  		if (result.status==='OK') {
  			this.refs.notificationSystem.addNotification({
	          title: 'แจ้งเตือน',
	          message: 'ทำการบันทึกเรียบร้อย',
	          level: 'info',
	          position: 'tc',        
	    	});
	      input_cash = DEFAULT_CASH
    		input_check = DEFAULT_CHECK
    		input_transfer = DEFAULT_TRANSFER
    		input_credit = DEFAULT_CREDIT
				this.setState({show:false,input_cash:input_cash,input_check:input_check,input_transfer:input_transfer,input_credit:input_credit},()=>{
					if (is_voucher){
						this.setState({showVoucher:true},()=>{
							this.refs.rvDoc.getWrappedInstance().loadInvoiceStatusNewDoc(this.props.ivNo)
						})
					}else if(this.props.docType==="invoice" && (taxinvoice_no==null||taxinvoice_no=="") && obj.payment_date && obj.payment_date!=""){
						this.setState({showConfirmTaxinvoice:true})
					}
				})
				if (this.props.onChange!==undefined) {
					this.props.onChange(obj)
				}	
  		}
  	})
	}

	onVoucherChange(status) {
		this.setState({is_voucher:status})
	}

	onConfirmClick(){
		
		if(window.create_new_identical_taxinvoice_from_invoice!==undefined){			
			
			window.create_new_identical_taxinvoice_from_invoice(this.props.ivNo,()=>{
				//Work Callback
				this.setState({showConfirmTaxinvoice:true})
			})
		}
	}

	// requestConfirmCancel(e){
	// 	this.setState({actionIndex:e,showConfirm:true,confirmMessage:'ต้องการจะยกเลิกเอกสาร '+this.props.docNo+' ?'})
	// }
	
	// requestConfirmReset(e){
	// 	this.setState({actionIndex:e,showConfirm:true,confirmMessage:'ต้องการจะรีเซ็ตข้อมูลการชำระเงิน '+this.props.docNo+'?'})
	// }

  resetPayment() {
  	let {input_cash,input_check,input_transfer,input_credit} = this.state
  	
  	let postData = {iv: this.props.ivNo, payment_detail: {}}
  	WorkdocStore.savePayment(postData,this.props.ivNo,this.props.docType,(result)=> {
  		if (result.status==='OK') {
  			this.refs.notificationSystem.addNotification({
	          title: 'แจ้งเตือน',
	          message: 'ทำการรีเซ็ตเรียบร้อย',
	          level: 'info',
	          position: 'tc',        
	        });
					input_cash = DEFAULT_CASH
					input_check = DEFAULT_CHECK
					input_transfer = DEFAULT_TRANSFER
					input_credit = DEFAULT_CREDIT
					this.setState({showConfirm:false,input_cash:input_cash,input_check:input_check,input_transfer:input_transfer,input_credit:input_credit,activeKey:1})
					if(this.props.onChange!==undefined){
						this.props.onChange({})
					}
  		}
  	},()=>{
			this.refs.notificationSystem.addNotification({
				title: 'แจ้งเตือน',
				message: 'ทำการรีเซ็ตไม่ได้',
				level: 'error',
				position: 'tc',        
			});
			this.setState({showConfirm:false})
		})
  }

  cancelPayment() {
  	let {input_cash,input_check,input_transfer,input_credit} = this.state
  	let that = this
  	let postData = {iv: this.props.ivNo}
  	WorkdocStore.cancelPayment(postData,this.props.ivNo,this.props.docType,function(result) {
  		if (result.status==='OK') {
  			that.refs.notificationSystem.addNotification({
	          title: 'แจ้งเตือน',
	          message: 'ทำการยกเลิกเรียบร้อย',
	          level: 'info',
	          position: 'tc',        
	        });
					input_cash = DEFAULT_CASH
					input_check = DEFAULT_CHECK
					input_transfer = DEFAULT_TRANSFER
					input_credit = DEFAULT_CREDIT
						that.setState({input_cash:input_cash,input_check:input_check,input_transfer:input_transfer,input_credit:input_credit})
  		}
  	})
  }

  onHide(){
    this.setState({show:false})
  }

  onTabsSelect(e) {
		let {activeKey,input_cash,input_check,input_credit,input_transfer} = this.state
		let amount = '';
		if(activeKey===1){
			amount = input_cash.amount
		}else if(activeKey===2){
			amount = input_check.amount
		}else if(activeKey===3){
			amount = input_transfer.amount
		}else if(activeKey===4){
			amount = input_credit.amount
		}
		input_cash.amount = amount
		input_check.amount = amount
		input_transfer.amount = amount
		input_credit.amount = amount
		this.setState({activeKey:e,input_cash:input_cash,input_check:input_check,input_transfer:input_transfer,input_credit:input_credit})
		
  }

  renderTab() {
  	let {activeKey} = this.state
  	let title = (<div><FontAwesome name='money' /> เงินสด</div>)
  	let title2 = (<div><FontAwesome name='pencil-square-o' /> เช็ค</div>)
  	let title3 = (<div><FontAwesome name='university' /> โอนเงิน</div>)
  	let title4 = (<div><FontAwesome name='credit-card' /> บัตรเครดิต</div>)
  	return(
  		<div>
    		<Row>
    			<Col md={12}>
    				<Tabs defaultActiveKey={activeKey} id='tabs-invoice-status-menu-button' onSelect={this.onTabsSelect.bind(this)}>
					  <Tab eventKey={1} title={title}>
					    {this.renderCash()}
					  </Tab>
					  <Tab eventKey={2} title={title2}>
					    {this.renderCheck()}
					  </Tab>
					  <Tab eventKey={3} title={title3}>
					    {this.renderTransfer()}
					  </Tab>
					  <Tab eventKey={4} title={title4}>
					    {this.renderCredit()}
					  </Tab>
					</Tabs>
    			</Col>
    		</Row>
    	</div>
  	)
  }

  getAmount(key) {
		let {input_cash,input_transfer,input_check,input_credit,taxIncluded} = this.state
		let sum = 0
		let input = this.state['input_'+key]
		if (input && input.wh_status===true) {
			let amount = 0
			let _amount = 0
		  if (isNaN(input.amount)===false&&input.amount!==undefined&&input.amount!==''&&input.amount!==null) {
				amount = input.amount
				_amount = input.amount
			}	
			if (taxIncluded) {
				amount = amount/1.07
			}
		  let vat_per = input.wh_val
		  let vat = (amount*vat_per) / 100
		  sum = taxIncluded?_amount - vat:amount - vat
		  input.net = sum
		  return parseFloat(sum)
	  } else {
		  if (input && isNaN(input.amount)===false&&input.amount!==undefined&&input.amount!==''&&input.amount!==null) {
			  sum = input.amount
		  }
		  input.net = sum
		  return parseFloat(sum)
	  }  
  }

  getBeforeVat(key){
		let {input_cash,input_transfer,input_check,input_credit,taxIncluded} = this.state
		let input = this.state['input_'+key]
		let amount = 0;
		if (input && isNaN(input.amount)===false&&input.amount!==undefined&&input.amount!==''&&input.amount!==null) {
			amount = input.amount
		}
		if (taxIncluded) {
			amount = amount/1.07
		}
		return parseFloat(amount)
  }

  getVat(key) {
		let {input_cash,input_transfer,input_check,input_credit,taxIncluded} = this.state
		let vat = 0
		let input = this.state['input_'+key]
		if (input && input.wh_status===true) {
			let amount = 0
			if (input && isNaN(input.amount)===false&&input.amount!==undefined&&input.amount!==''&&input.amount!==null) {
				amount = input.amount
			  }	
			  if (taxIncluded) {
				  amount = amount/1.07
			  }
			let vat_per = input.wh_val
			let vat = (amount*vat_per) / 100
			return parseFloat(vat)
		} else {
			return parseFloat(vat)
		}  	
	}

	onTaxIncludedChange() {
		let {taxIncluded} = this.state
		if (taxIncluded)
			taxIncluded = false
		else
			taxIncluded = true
			
		this.setState({taxIncluded:taxIncluded})	
	}
	
	renderCheckboxTaxIncluded(type) {
		let {taxIncluded} = this.state
		return(
								<FormGroup
				          controlId="formBasicText"
				          validationState={null}
				          style={{marginTop:(type==='transfer'||type==='credit'?'':'50px')}}
				        >
									<Checkbox
	                  onChange={this.onTaxIncludedChange.bind(this)}
	                  checked={taxIncluded}
	                  checkboxClass="icheckbox_square-blue"
	                  increaseArea="20%"
	                  label=" ราคารวมภาษี"
	                >
	                </Checkbox>
				        </FormGroup>
		)
	}

  renderCash() {
  	let {input_cash} = this.state
  	return(
  		<div style={{marginTop:'30px'}}>
  				<Row>
    		      <Col md={3}></Col>
    		      <Col md={6}>
	    			<Form>
								{this.renderDate('cash')}
								{this.renderCheckboxTaxIncluded('cash')}
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
									<span className='text-red'>*</span>
				          <ControlLabel>จำนวนเงิน</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_cash.amount}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'cash','amount')}
				          />
				        </FormGroup>
				    </Form>
				  </Col>
				  <Col md={3}></Col>
				</Row>
				{this.renderWhButton('cash')}
				<Row>
    		      <Col md={3}></Col>
    		      <Col md={6}>
	    			<Form>
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>ยอดสุทธิ</ControlLabel>
				          <FormControl
				          	readOnly={true}
				            type="text"
				            value={this.getAmount('cash').toLocaleString(undefined, {maximumFractionDigits: 2})}
				            placeholder=""
				          />
				        </FormGroup>
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>หมายเหตุ</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_cash.remark}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'cash','remark')}
				          />
				        </FormGroup>
				    </Form>
				  </Col>
				  <Col md={3}></Col>
				</Row>
		</div>		
  	)
  }

  renderCheck() {
  	let {input_check} = this.state
  	return(
  		<div style={{marginTop:'30px'}}>
  				<Row>
    		      <Col md={3}></Col>
    		      <Col md={6}>
	    			<Form>
				        {this.renderDate('check')}
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				          style={{marginTop:'50px'}}
				        >
				          <ControlLabel>ธนาคาร</ControlLabel>
				          <CKAutocomplete
		                    top={'-34px'}
		                    items={this.state.bankList}
		                    value={input_check.bank}
		                    onChange={this.onTextChange.bind(this,'check','bank')}
		                    onSelect={this.onTextSelect.bind(this,'check','bank')}
		                  />
				        </FormGroup>
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>เลขที่</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_check.number}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'check','number')}
				          />
				        </FormGroup>
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>วันที่หน้าเช็ค</ControlLabel>
				          <DatePicker
						    value={input_check.check_date}
						    onChange={this.onCheckDateChange.bind(this)}
						    showIcon={false}
						    showFooter={true}
						    buddhistEra={true}
						    formG={'unset'}
						    inputG={'unset'}
						    maxWidth={'100%'}
						  />
				        </FormGroup>
								{this.renderCheckboxTaxIncluded('check')}
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>จำนวนเงิน</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_check.amount}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'check','amount')}
				          />
				        </FormGroup>
				    </Form>
				  </Col>
				  <Col md={3}></Col>
				</Row>
				{this.renderWhButton('check')}
				<Row>
    		      <Col md={3}></Col>
    		      <Col md={6}>
	    			<Form>
	    				<FormGroup
				          controlId="formBasicText"
				          validationState={null}
				          style={{marginTop:'10px'}}
				        >
				          <ControlLabel>ค่าธรรมเนียม</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_check.fee}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'check','fee')}
				          />
				        </FormGroup>
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>ยอดสุทธิ</ControlLabel>
				          <FormControl
				          	readOnly={true}
				            type="text"
				            value={this.getAmount('check').toLocaleString(undefined, {maximumFractionDigits: 2})}
				            placeholder=""
				          />
				        </FormGroup>
				    </Form>
				  </Col>
				  <Col md={3}></Col>
				</Row>
  		</div>
  	)
  }

  renderTransfer() {
  	let {input_transfer} = this.state
  	return(
  		<div style={{marginTop:'30px'}}>
  				<Row>
    		      <Col md={3}></Col>
    		      <Col md={6}>
	    			<Form>
				        {this.renderDate('transfer')}
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				          style={{marginTop:'50px'}}
				        >
				          <ControlLabel>ธนาคาร</ControlLabel>
				          <CKAutocomplete
		                    top={'-34px'}
		                    items={this.state.bankList}
		                    value={input_transfer.bank}
		                    onChange={this.onTextChange.bind(this,'transfer','bank')}
		                    onSelect={this.onTextSelect.bind(this,'transfer','bank')}
		                  />
				        </FormGroup>
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>เลขที่</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_transfer.number}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'transfer','number')}
				          />
				        </FormGroup>
								{this.renderCheckboxTaxIncluded('transfer')}
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>จำนวนเงิน</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_transfer.amount}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'transfer','amount')}
				          />
				        </FormGroup>
				    </Form>
				  </Col>
				  <Col md={3}></Col>
				</Row>
				{this.renderWhButton('transfer')}
				<Row>
    		      <Col md={3}></Col>
    		      <Col md={6}>
	    			<Form>
	    				<FormGroup
				          controlId="formBasicText"
				          validationState={null}
				          style={{marginTop:'10px'}}
				        >
				          <ControlLabel>ค่าธรรมเนียม</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_transfer.fee}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'transfer','fee')}
				          />
				        </FormGroup>
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>ยอดสุทธิ</ControlLabel>
				          <FormControl
				          	readOnly={true}
				            type="text"
				            value={this.getAmount('transfer').toLocaleString(undefined, {maximumFractionDigits: 2})}
				            placeholder=""
				          />
				        </FormGroup>
				    </Form>
				  </Col>
				  <Col md={3}></Col>
				</Row>
  		</div>
  	)
  }

  renderCredit() {
  	let {input_credit} = this.state
  	return(
  		<div style={{marginTop:'30px'}}>
  				<Row>
    		      <Col md={3}></Col>
    		      <Col md={6}>
	    			<Form>
				        {this.renderDate('credit')}
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				          style={{marginTop:'50px'}}
				        >
				          <ControlLabel>ธนาคาร</ControlLabel>
				          <CKAutocomplete
		                    top={'-34px'}
		                    items={this.state.bankList}
		                    value={input_credit.bank}
		                    onChange={this.onTextChange.bind(this,'credit','bank')}
		                    onSelect={this.onTextSelect.bind(this,'credit','bank')}
		                  />
				        </FormGroup>
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>บัตรเครดิต</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_credit.credit}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'credit','credit')}
				          />
				        </FormGroup>
								{this.renderCheckboxTaxIncluded('credit')}
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>จำนวนเงิน</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_credit.amount}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'credit','amount')}
				          />
				        </FormGroup>
				    </Form>
				  </Col>
				  <Col md={3}></Col>
				</Row>
				{this.renderWhButton('credit')}
				<Row>
    		      <Col md={3}></Col>
    		      <Col md={6}>
	    			<Form>
	    				<FormGroup
				          controlId="formBasicText"
				          validationState={null}
				          style={{marginTop:'10px'}}
				        >
				          <ControlLabel>ค่าธรรมเนียม</ControlLabel>
				          <FormControl
				            type="text"
				            value={input_credit.fee}
				            placeholder=""
				            onChange={this.onTextChange.bind(this,'credit','fee')}
				          />
				        </FormGroup>
				        <FormGroup
				          controlId="formBasicText"
				          validationState={null}
				        >
				          <ControlLabel>ยอดสุทธิ</ControlLabel>
				          <FormControl
				          	readOnly={true}
				            type="text"
				            value={this.getAmount('credit').toLocaleString(undefined, {maximumFractionDigits: 2})}
				            placeholder=""
				          />
				        </FormGroup>
				    </Form>
				  </Col>
				  <Col md={3}></Col>
				</Row>
    	</div>
    )		      
  }

  onWhClick(key) {
  	let {input_cash,input_check,input_transfer,input_credit} = this.state
  	if (key==='cash') {
  		if (input_cash.wh_status) {
	  		input_cash.wh_status = false
	  	} else {
	  		input_cash.wh_status = true
	  	}
	  	this.setState({input_cash:input_cash})
  	} else if (key==='check') {
  		if (input_check.wh_status) {
	  		input_check.wh_status = false
	  	} else {
	  		input_check.wh_status = true
	  	} 
	  	this.setState({input_check:input_check})
  	} else if (key==='transfer') {
  		if (input_transfer.wh_status) {
	  		input_transfer.wh_status = false
	  	} else {
	  		input_transfer.wh_status = true
	  	}
	  	this.setState({input_transfer:input_transfer})
  	} else if (key==='credit') {
  		if (input_credit.wh_status) {
	  		input_credit.wh_status = false
	  	} else {
	  		input_credit.wh_status = true
	  	} 
	  	this.setState({input_credit:input_credit})
  	}
  }

  onWhChange(key,e) {
  	let {input_cash,input_check,input_transfer,input_credit} = this.state
  	if (key==='cash') {
  		input_cash.wh_val = e.value
  		this.setState({input_cash:input_cash})
  	} else if (key==='check') {
  		input_check.wh_val = e.value
  		this.setState({input_check:input_check})
  	} else if (key==='transfer') {
  		input_transfer.wh_val = e.value 
  		this.setState({input_transfer:input_transfer})
  	} else if (key==='credit') {
  		input_credit.wh_val = e.value 
  		this.setState({input_credit:input_credit})
  	}
  }

  onDateChange(key,e) {
  	let {input_cash,input_check,input_transfer,input_credit} = this.state
  	if (key==='cash') {
  		input_cash.payment_date = e
  		this.setState({input_cash:input_cash})
  	} else if (key==='check') {
  		input_check.payment_date = e
  		this.setState({input_check:input_check})
  	} else if (key==='transfer') {
  		input_transfer.payment_date = e
  		this.setState({input_transfer:input_transfer})
  	} else if (key==='credit') {
  		input_credit.payment_date = e
  		this.setState({input_credit:input_credit})
  	}
  }

  onCheckDateChange(e) {
  	let {input_check} = this.state
  	input_check.check_date = e
  	this.setState({input_check:input_check})	
	}
	
	onConfirmPopup(){
		let {actionIndex} = this.state
		if(actionIndex==='2'){

		}else if(actionIndex==='3'){		
			this.cancelPayment()
		}else if(actionIndex==='4'){
			this.resetPayment()
		}
	}

  renderDate(key) {
  	let {input_cash,input_check,input_transfer,input_credit} = this.state
  	let date = ''
  	if (key==='cash') {
  		date = input_cash.payment_date
  	} else if (key==='check') {
  		date = input_check.payment_date
  	} else if (key==='transfer') {
  		date = input_transfer.payment_date
  	} else if (key==='credit') {
  		date = input_credit.payment_date
  	}
  	return(
  		<FormGroup
			controlId="formBasicText"
			validationState={null}
		>
		 	<span className='text-red'>*</span>
			<ControlLabel>วันที่รับชำระเงิน</ControlLabel>
			<DatePicker
			    value={date}
			    onChange={this.onDateChange.bind(this,key)}
			    showIcon={false}
			    showFooter={true}
			    buddhistEra={true}
			    formG={'unset'}
			    inputG={'unset'}
			    maxWidth={'100%'}
			/>
		</FormGroup>
  	)
  }

  renderWhButton(key) {
  	let {input_cash,input_check,input_transfer,input_credit,taxIncluded} = this.state
  	let show_wh = false
  	let val_wh = ''
  	if (key==='cash') {
  		show_wh = input_cash.wh_status
  		val_wh = input_cash.wh_val
  	} else if (key==='check') {
  		show_wh = input_check.wh_status
  		val_wh = input_check.wh_val
  	} else if (key==='transfer') {
  		show_wh = input_transfer.wh_status
  		val_wh = input_transfer.wh_val
  	} else if (key==='credit') {
  		show_wh = input_credit.wh_status
  		val_wh = input_credit.wh_val
  	}
  	return(
  		<div>
	  		<Row>
	    		<Col md={3}></Col>
	    		<Col md={6}>
					<Checkbox
	                  onChange={this.onWhClick.bind(this,key)}
	                  checked={show_wh}
	                  checkboxClass="icheckbox_square-blue"
	                  increaseArea="20%"
	                  label=" หัก ณ ที่จ่าย"
	                >
	                </Checkbox>
				</Col>
				<Col md={3}></Col>
			</Row>
			<Row style={{display:show_wh?'block':'none',marginTop:'10px'}}>
					<Col md={3}></Col>
					<Col md={6}>
						ยอดรวมก่อนภาษี {this.getBeforeVat(key).toLocaleString(undefined, {maximumFractionDigits: 2})}
					</Col>
			</Row>
			<Row style={{display:show_wh?'block':'none',marginTop:'10px'}}>
	    		<Col md={3}></Col>
	    		<Col md={6}>
	    			<Row>
	    				<Col md={6}>
	    					<Select
					            clearable={false}
					            name="form-field-name"
					            value={val_wh}
					            options={[{label:'0.5%',value:0.5},{label:'0.75%',value:0.75},{label:'1%',value:1},{label:'1.5%',value:1.5},{label:'2%',value:2},{label:'3%',value:3},{label:'5%',value:5},{label:'10%',value:10},{label:'15%',value:15}]}
					            placeholder='เลือกอัตราภาษี'
					            onChange={this.onWhChange.bind(this,key)}
					        />
						</Col>
						<Col md={6}>
							<FormControl readOnly={true} value={this.getVat(key).toLocaleString(undefined, {maximumFractionDigits: 2})} />
						</Col>	    				
	    			</Row> 
				</Col>
				<Col md={3}></Col>
			</Row>
		</div>
  	)
  }

  renderButton() {
  	return(
  	  <div>
				<Checkbox
	        onChange={this.onVoucherChange.bind(this,(this.state.is_voucher?false:true))}
	        checked={this.state.is_voucher}
	        checkboxClass="icheckbox_square-blue"
	        increaseArea="20%"
	        label=" สร้างใบสำคัญรับ"
	      >
	      </Checkbox>
				{' '}
        <Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}>
          <FontAwesome name="save" />&nbsp;ยืนยัน
        </Button>
        <Button className="btn btn-default" onClick={this.onHide.bind(this)}>
          <FontAwesome name="remove" />&nbsp;ยกเลิก
        </Button>
      </div>
    )  
  }

  onTextChange(pay,key,e) {
  	let {input_cash,input_check,input_transfer,input_credit} = this.state
  	if (pay==='cash') {
  		input_cash[key] = e.target.value
  		this.setState({input_cash:input_cash})
  	}else if (pay==='check') {
  		input_check[key] = e.target.value
  		this.setState({input_check:input_check})
  	}else if (pay==='transfer') {
  		input_transfer[key] = e.target.value
  		this.setState({input_transfer:input_transfer})
  	}else if (pay==='credit') {
  		input_credit[key] = e.target.value
  		this.setState({input_credit:input_credit})
  	}
  }

  onTextSelect(pay,key,e,item) {
	  let {input_cash,input_check,input_transfer,input_credit} = this.state
	  console.log("item select",item);
	  
	  

  	if (pay==='cash') {
  		input_cash[key] = e
  		this.setState({input_cash:input_cash})
  	}else if (pay==='check') {
		input_check[key] = e		  
		if(item.account_number && item.account_number.length>0){
			input_check["number"] = item.account_number[0]
		}
  		this.setState({input_check:input_check})
  	}else if (pay==='transfer') {
		input_transfer[key] = e
		if(item.account_number && item.account_number.length>0){
			input_transfer["number"] = item.account_number[0]
		}
  		this.setState({input_transfer:input_transfer})
  	}else if (pay==='credit') {
  		input_credit[key] = e
  		this.setState({input_credit:input_credit})
  	}
  }

  onDropdownSelect(e) {
  	if (e==='2') {
  		this.loadPayment()
  	} else if (e==='3') { 
  		//this.requestConfirmCancel(e)
      this.setState({remarkTitle:'ยกเลิกบิลหมายเลข '+this.props.docNo,showRemark:true,docTag:'cancel',actionIndex:e})
  	} else if (e==='4') {
  		//this.requestConfirmReset(e)
      this.setState({remarkTitle:'รีเซ็ตบิลหมายเลข '+this.props.docNo,showRemark:true,docTag:'resetpayment',actionIndex:e})
  	}
  }

  onRemarkClose(e) {
    this.setState({showRemark:false,remarkTitle:''})
  }

  onRemarkSuccess(e) {
    this.setState({showRemark:false,remarkTitle:''})
    let {actionIndex} = this.state

		//console.log('onConfirm',actionIndex)
		if(actionIndex==='2'){

		}else if(actionIndex==='3'){		
			this.cancelPayment()
		}else if(actionIndex==='4'){
			this.resetPayment()
		}
	}
	
	renderVoucherModal() {
		let {showVoucher} = this.state
		return(
			<div>
				<Modal show={showVoucher} enforceFocus={false} onHide={()=>{this.setState({showVoucher:false})}} dialogClassName="fullwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>ใบสำคัญรับ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
						<ReceiptVoucherDoc                 
              ref='rvDoc' 
              title={'ใบสำคัญรับ'}
              docType={'receiptvoucher'}
              docSName={'rv'}
							docName={'receiptvoucher_doc'}
							invoiceStatusDocType={this.props.docType}
              onClose={()=>{this.setState({showVoucher:false})}}
            />
          </Modal.Body>
        </Modal>
			</div>
		)
	}

  render(){
		let {docNo} = this.props
		let {show}  = this.state
		let title = (<span><FontAwesome name='list'/> เปลี่ยนสถานะ</span>)
		
    return (
      <div>
        <DropdownButton
	      bsStyle={'primary'}
	      title={title}
	      key={0}
	      id={'dropdown-invoice-status-menu-button'}
	      onSelect={this.onDropdownSelect.bind(this)}
	    >	      
	      <MenuItem eventKey="2"><FontAwesome name='money'/> เก็บเงินแล้ว</MenuItem>
	      <MenuItem eventKey="3"><FontAwesome name='ban'/> ยกเลิก</MenuItem>
	      <MenuItem divider />
	      <MenuItem eventKey="4"><FontAwesome name='undo'/> รีเซ็ต</MenuItem>
	    </DropdownButton>  
        <Modal show={show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="smallwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{'วิธีการชำระเงินเอกสาร '+docNo}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              {this.renderTab()} 
          </Modal.Body>
          <Modal.Footer>
            {this.renderButton()}
          </Modal.Footer>
        </Modal>   
				<RemarkRecordModal
          show={this.state.showRemark}
          onHide={()=>this.setState({showRemark:false})}
          onModalClose={this.onRemarkClose.bind(this)}
          docName={this.props.docType}
		  		docNo={this.props.ivNo}
		  		docTag={this.state.docTag}
          docTitle={this.state.remarkTitle}
          onSuccess={this.onRemarkSuccess.bind(this)}
        />
				{this.renderVoucherModal()}
		<NotificationSystem ref="notificationSystem" />   
		<ConfirmPopup
			show={this.state.showConfirmTaxinvoice}
			message={'ต้องการสร้างรายการใบกำกับภาษีด้วยหรือไม่ ?'}
			cancelTitle="ไม่ต้องการ"
			onConfirm={this.onConfirmClick.bind(this)}
			onHide={()=>this.setState({showConfirmTaxinvoice:false})}
		/>		
      </div>
    )
  }
}


InvoiceStatusMenuButton.defaultProps = {
	docType:'taxinvoice',
	ivNo:'',
	docNo:'',
	amount:'',
	hasVat:true
}
export default InvoiceStatusMenuButton;


// WEBPACK FOOTER //
// ./src/view/menu/invoicestatus/InvoiceStatusMenuButton.js